import { FunctionComponent, useContext } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import { MarkdownDisplay } from "@kanda-libs/ks-component-ts";
import LineItemContext from "components/job/LineItem/LineItemContext";
import { SKELETONS } from "components/job/LineItem/constants";

export interface TotalProps {}

const Total: FunctionComponent<TotalProps> = () => {
  const { description = "", classNames } = useContext(LineItemContext);

  return (
    <Text
      className={classNames.description}
      text={<MarkdownDisplay>{description}</MarkdownDisplay>}
      skeletonProps={SKELETONS.description}
    />
  );
};

export default Total;
